import { render, staticRenderFns } from "./ProductsTableAva.vue?vue&type=template&id=7a9e6d8b&"
import script from "./ProductsTableAva.vue?vue&type=script&lang=js&"
export * from "./ProductsTableAva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports